// tslint:disable: completed-docs
import { connect, injectReducer, injectSaga } from '@vfde-sails/core';

import { RootState } from './types';

import offerDisplayReducer from 'Container/OfferDisplay/reducer';
import { createStructuredSelector } from 'reselect';
import {
    selectAdditionalContentDownloaded,
    selectCurrentOffers,
} from 'Container/OfferDisplay/selector';
import offerDisplaySaga from 'Container/OfferDisplay/saga';
import {
    setDefaultState,
    setCurrentOffers,
    setAdditionalContentDownloaded,
} from 'Container/OfferDisplay/action';
import { OFFER_DISPLAY_CONTAINER } from 'Constant';
import { OFFER_DISPLAY_STORE } from './constant';
import { renderOffers } from 'Container/OfferDisplay/helpers/renderers/offersRenderHelper';
import { maletsoScan } from 'Helper/matelsoHelper';
import {
    offerAlreadyVisible,
} from 'Container/Landingpage/action';
import {
    accordionOpened,
    buttonOfferPriceClick,
} from 'Container/Tracking/action';
import { renderAdditionalContents } from 'Container/OfferDisplay/helpers/renderers/additionalContentsHelper';
import { handleLegacyClickEventBindings, trackApplyFilterIfInViewport } from './helpers/eventHelper';

interface StateProps {
    currentOffers: boolean;
    additionalContentDownloaded: boolean;
}

/**
 * PreDataHandler function
 */
function OfferDisplay (state, action) {

    injectReducer(OFFER_DISPLAY_STORE, offerDisplayReducer);
    injectSaga(OFFER_DISPLAY_STORE, offerDisplaySaga);

    action.setDefaultState();

    return {

        /**
         * This function is called on first load and everytime the store changes.
         * @param newState
         * @param oldState - You may also pass the oldState here, if needed
         */
        getDerivedStateFromProps (newState, oldState) {

            if (newState.currentOffers !== oldState.currentOffers) {
                renderStandardOffers(newState, oldState, action);
                if (newState.additionalContentDownloaded) {
                    renderAdditionalContents(newState.currentOffers);
                }
            } else {
                // newState.currentOffers === oldState.currentOffers in two cases:
                // 1) offers were not downloaded yet
                // 2) Additional content were downloaded after standard offers
                if (newState.additionalContentDownloaded && newState.currentOffers) {
                    renderAdditionalContents(newState.currentOffers);
                }
            }
        },
    };
}

const renderStandardOffers = (newState, oldState, action) => {

    const offerDisplayContainer = document.getElementById(OFFER_DISPLAY_CONTAINER);
    // display Offer-Details
    renderOffers(offerDisplayContainer, newState, action.buttonOfferPriceClick, action.accordionOpened);

    // attach Clic-Events
    handleLegacyClickEventBindings();

    // do another Matelso Scan
    maletsoScan();

    // if first called, check, if Offer-details are already in Viewport
    if (true === oldState.initializing && false === newState.initializing) {
        // display offer on pageload => check, if offer is already in viewport
        trackApplyFilterIfInViewport(action.offerAlreadyVisible);
    }

    // init Click on accordion
    // @ToDo: attach event to brix component
    // handleAccordionChangeEvent(action.accordionOpened);
};

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
    currentOffers: selectCurrentOffers(),
    additionalContentDownloaded: selectAdditionalContentDownloaded(),
});

const mapDispatch = {
    setDefaultState,
    offerAlreadyVisible,
    setCurrentOffers,
    accordionOpened,
    buttonOfferPriceClick,
    setAdditionalContentDownloaded,
};

const offerDisplay = connect(mapStateToProps, mapDispatch)(OfferDisplay);
export default offerDisplay;
